import { styled } from '@mui/material';

export const UsersList = styled('ul')({
	listStylePosition: 'inside',
});
